export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: {
      guest: true,
      public: true
    },
    name: 'Root',
    redirect: {
      name: 'Login'
    },

  },
  {
    path: '/login',
    meta: {
      guest: true,
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    ),

  },

  {
    path: '/dashboard',
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: 'Dashboard',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Dashboard.vue`
    )
  },

  {
    path: '/administracion/autores',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'autores',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Autores.vue`
    )
  },
  {
    path: '/administracion/usuarios',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'usuarios',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Usuarios.vue`
    )
  },
  {
    path: '/administracion/categorias',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'categorias',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Categorias.vue`
    )
  },
  {
    path: '/administracion/editoriales',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'editoriales',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Editoriales.vue`
    )
  }, {
    path: '/administracion/libros',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'libros',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Libros.vue`
    )
  },
  {
    path: '/administracion/bitacora',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'bitacora',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/Bitacora.vue`
    )
  },
  {
    path: '/administracion/libroswizard',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    name: 'libroswizard',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/LibrosWizard.vue`
    )
  },
  {
    path: '/administracion/newprestamo',
    meta: {
      breadcrumb: false,
      requiresAuth: true
    },
    props: true,
    name: 'newprestamo',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/administracion/newPrestamo.vue`
    )
  },

];



